import { SvgIcon, SvgIconProps } from '@mui/material';

export const ViatorLogo = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="128"
        height="32"
        viewBox="0 0 128 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="128" height="32" fill="#F5F5F5" />
        <path
          d="M-2655 -1175C-2655 -1176.1 -2654.1 -1177 -2653 -1177H2606C2607.1 -1177 2608 -1176.1 2608 -1175V2482C2608 2483.1 2607.1 2484 2606 2484H-2653C-2654.1 2484 -2655 2483.1 -2655 2482V-1175Z"
          fill="#EEEEEE"
        />
        <path
          d="M-2653 -1176H2606V-1178H-2653V-1176ZM2607 -1175V2482H2609V-1175H2607ZM2606 2483H-2653V2485H2606V2483ZM-2654 2482V-1175H-2656V2482H-2654ZM-2653 2483C-2653.55 2483 -2654 2482.55 -2654 2482H-2656C-2656 2483.66 -2654.66 2485 -2653 2485V2483ZM2607 2482C2607 2482.55 2606.55 2483 2606 2483V2485C2607.66 2485 2609 2483.66 2609 2482H2607ZM2606 -1176C2606.55 -1176 2607 -1175.55 2607 -1175H2609C2609 -1176.66 2607.66 -1178 2606 -1178V-1176ZM-2653 -1178C-2654.66 -1178 -2656 -1176.66 -2656 -1175H-2654C-2654 -1175.55 -2653.55 -1176 -2653 -1176V-1178Z"
          fill="black"
          fillOpacity="0.1"
        />
        <g clipPath="url(#clip0_416_30439)">
          <rect width="1440" height="1024" transform="translate(-656 -358)" fill="white" />
          <g clipPath="url(#clip1_416_30439)">
            <path
              d="M125.067 27.1301C126.056 27.0752 126.907 27.844 126.962 28.8601C127.017 29.8487 126.248 30.6999 125.232 30.7549C124.244 30.8098 123.392 30.0409 123.337 29.0249C123.337 28.9974 123.337 28.9699 123.337 28.9425C123.337 27.9539 124.106 27.1575 125.067 27.1301ZM125.067 26.8555C123.914 26.8555 123.008 27.7891 123.008 28.915C123.008 30.0683 123.941 30.9745 125.067 30.9745C126.193 30.9745 127.127 30.0409 127.127 28.915C127.154 27.7891 126.221 26.8555 125.067 26.8555ZM125.369 28.9699C125.617 28.915 125.809 28.6953 125.809 28.4207C125.809 28.0363 125.479 27.8715 125.012 27.8715H124.408V29.931H124.765V28.9974H125.04L125.479 29.6839C125.617 29.9036 125.644 29.9036 125.836 29.9036H126.001V29.931L125.369 28.9699ZM125.012 28.9425H124.765V28.0088H124.985C125.342 28.0088 125.479 28.1461 125.479 28.4756C125.479 28.8052 125.369 28.9425 125.012 28.9425Z"
              fill="#196C6E"
            />
            <path d="M35.884 6.15234H28.25V30.9766H35.884V6.15234Z" fill="#196C6E" />
            <path
              d="M77.6973 28.5042C75.4455 28.5042 74.3746 27.1586 74.3746 24.8519V8.2109H80.4708V6.15137H74.402V-0.0546875H67.0701L66.7131 6.15137H63.4453V8.2109H66.7131V24.5773C66.7131 28.8062 69.1296 31.5523 74.0725 31.5523C77.7797 31.5523 79.9765 30.042 80.8827 28.0099L80.5257 27.6254C79.7019 28.2021 78.7133 28.5316 77.6973 28.5042Z"
              fill="#196C6E"
            />
            <path
              d="M93.6894 5.60156C85.5337 5.60156 80.3711 11.2859 80.3711 18.7002C80.3711 26.0596 85.2041 31.5517 93.5246 31.5517C102.01 31.5517 106.843 25.8674 106.843 18.4531C106.816 11.0937 101.763 5.60156 93.6894 5.60156ZM93.6345 29.7668C89.5429 29.7668 88.9662 26.444 88.9662 18.508C88.9662 10.7092 89.5154 7.33157 93.5796 7.33157C97.6712 7.33157 98.2478 10.7092 98.2478 18.6178C98.2204 26.3891 97.7261 29.7668 93.6345 29.7668Z"
              fill="#196C6E"
            />
            <path
              d="M117.517 10.4367L117.352 6.15284H109.938V30.9771H117.599V11.0957C118.066 10.9584 118.533 10.876 119.027 10.876C120.4 10.876 121.965 11.4252 126.743 13.677L127.183 13.5122V6.53729C126.304 5.9057 125.233 5.57617 124.162 5.57617C121.993 5.60363 119.494 6.94919 117.517 10.4367Z"
              fill="#196C6E"
            />
            <path
              d="M53.5404 28.0114L54.4192 30.9771H60.9548V11.8646C60.9548 7.6357 57.6321 5.57617 52.1949 5.57617C48.5426 5.57617 44.0391 6.59221 40.9636 7.60824L40.6066 11.947L41.0459 12.1667C46.895 8.23983 48.625 7.33364 50.4374 7.33364C52.497 7.33364 53.3482 8.4046 53.3482 10.6564V15.8189C44.6982 17.6038 39.4258 18.9219 39.4258 24.7985C39.4258 28.8352 42.1169 31.5537 46.4557 31.5537C49.7784 31.5537 52.2498 29.9885 53.5404 28.0114ZM46.9774 23.398C46.9774 19.581 48.268 18.6199 53.3757 17.5489V27.1052C52.442 27.8466 51.2887 28.231 50.1079 28.1761C47.9385 28.1761 46.9774 26.9404 46.9774 23.398Z"
              fill="#196C6E"
            />
            <path
              d="M20.3948 14.9655C22.9731 14.9655 25.0631 12.8754 25.0631 10.2972C25.0631 7.71896 22.9731 5.62891 20.3948 5.62891C17.8166 5.62891 15.7266 7.71896 15.7266 10.2972C15.7266 12.8754 17.8166 14.9655 20.3948 14.9655Z"
              fill="#196C6E"
            />
            <path
              d="M15.2642 31.004L17.7081 25.5394L9.08556 6.15234H0.902344L11.9689 31.004H15.2642Z"
              fill="#196C6E"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_416_30439">
            <rect width="1440" height="1024" fill="white" transform="translate(-656 -358)" />
          </clipPath>
          <clipPath id="clip1_416_30439">
            <rect width="126.061" height="32" fill="white" transform="translate(0.96875)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
